import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-month-view-datepicker-header',
  templateUrl: './month-view-datepicker-header.component.html',
  styleUrls: ['./month-view-datepicker-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonthViewDatepickerHeaderComponent {
  constructor(private calendar: MatCalendar<Date>, private dateAdapter: DateAdapter<Date>) {}

  get periodLabel(): Date {
    return this.calendar.activeDate;
  }

  previousClicked(): void {
    this.calendar.activeDate = this.dateAdapter.addCalendarMonths(this.calendar.activeDate, -1);
  }

  nextClicked(): void {
    this.calendar.activeDate = this.dateAdapter.addCalendarMonths(this.calendar.activeDate, 1);
  }
}
